import $ from 'jquery';
import React from 'react';
import LogoImg from '../assets/images/logo_p_small.png';
import {UserToken,getUserObjData,getAccessFunctions} from '../function_lib/userToken';
import {setProfilePic,defaultClick,getAccessRolesNew,CallMapMethod,CallMapMethod_CBack,_getInitParam} from '../function_lib/common_lib';
import {CallCMSMapMethod} from '../function_lib/common_cms';
import UserDefault from '../assets/images/9.png';


import './header.css';
let listRoles;
let loginUser;
let userObject;
let companyName="";
let clsObject;

let _initObjectLib;

class Header extends React.Component{
  logout(){
    localStorage.clear();
    window.location.href="../";
  }

  

  constructor(props){
  super(props);
    listRoles=[];
    if(localStorage.getItem("userData")!=null){
      userObject= getUserObjData();
      //alert(JSON.stringify(userObject));
      loginUser=userObject[0].first_name;
      if(typeof userObject[0].company_name!=="undefined"){
        companyName=userObject[0].company_name;
      }
      _initObjectLib=_getInitParam();
      //alert(LogoImg);
  }
  let ret=getAccessFunctions();
 if(userObject[0].type==="1" || userObject[0].type==="2" || userObject[0].type==="3"){

    listRoles.push({"id":"1","name":"Dashboard","parent_id":"0","red_link":"../dashboard","description":"","display_option":"menu"});
    if(userObject[0].type==="1" && ret==="user,master"){
      
      if(_initObjectLib.app_settings.settings.menu_category["menu_type"]==="all" || _initObjectLib.app_settings.settings.menu_category["menu_type"]==="e-com")
      {
        
        listRoles.push({"id":"5","name":"Admin","parent_id":"0","red_link":"../dashboard","description":"","display_option":"menu"});
        //listRoles.push({"id":"51","name":"Staff","parent_id":"5","red_link":"../user_mgmt","description":"","display_option":"menu"});
        listRoles.push({"id":"52","name":"Product Vendors","parent_id":"5","red_link":"../product_vendors","description":"","display_option":"menu"});
    
        listRoles.push({"id":"53","name":"Category Master","parent_id":"5","red_link":"../category_master","description":"","display_option":"menu"});
        //listRoles.push({"id":"81","name":"Team Users","parent_id":"5","red_link":"../dashboard","description":"","display_option":"menu"});
        //listRoles.push({"id":"82","name":"Web Users","parent_id":"5","red_link":"../thrashold_limit","description":"","display_option":"menu"});
    
        //listRoles.push({"id":"52","name":"Slot Size","parent_id":"5","red_link":"../slot_size","description":"","display_option":"menu"});
        //listRoles.push({"id":"52","name":"User Settings","parent_id":"5","red_link":"../user_settings","description":"","display_option":"menu"});
        //listRoles.push({"id":"53","name":"Queue Monitor","parent_id":"5","red_link":"../queue_monitor","description":"","display_option":"menu"});
        //listRoles.push({"id":"54","name":"Push Messages","parent_id":"5","red_link":"../push_messages","description":"","display_option":"menu"});
        
        listRoles.push({"id":"7","name":"Registered Users","parent_id":"5","red_link":"../user_mgmt","description":"","display_option":"menu"});

      }
    
    }
    else if(userObject[0].type==="1" && ret==="user"){
      // access menu for use
      if(_initObjectLib.app_settings.settings.menu_category["menu_type"]==="all" || _initObjectLib.app_settings.settings.menu_category["menu_type"]==="e-com")
      {
        listRoles.push({"id":"7","name":"Web Users","parent_id":"0","red_link":"../user_mgmt","description":"","display_option":"menu"});
      }
      
    }
    if(_initObjectLib.app_settings.settings.menu_category["menu_type"]==="all" || _initObjectLib.app_settings.settings.menu_category["menu_type"]==="e-com")
    {
      listRoles.push({"id":"2","name":"Product Master","parent_id":"0","red_link":"../add_product_master","description":"","display_option":"menu"});
      listRoles.push({"id":"21","name":"Add New Product","parent_id":"2","red_link":"../add_product_master","description":"","display_option":"menu"});
      listRoles.push({"id":"22","name":"View Products","parent_id":"2","red_link":"../view_product_master","description":"","display_option":"menu"});
      listRoles.push({"id":"23","name":"Stock Update","parent_id":"2","red_link":"../stock_update","description":"","display_option":"menu"});
      listRoles.push({"id":"24","name":"Create Coupons","parent_id":"2","red_link":"../coupon_master","description":"","display_option":"menu"});
  
      listRoles.push({"id":"3","name":"Online Orders","parent_id":"0","red_link":"../online_orders","description":"","display_option":"menu"});
      listRoles.push({"id":"6","name":"Contact/Ratings","parent_id":"0","red_link":"../contact_request","description":"","display_option":"menu"});
      listRoles.push({"id":"61","name":"View Ratings","parent_id":"6","red_link":"../view_ratings","description":"","display_option":"menu"});
      listRoles.push({"id":"62","name":"View Messages","parent_id":"6","red_link":"../view_messages","description":"","display_option":"menu"});
      listRoles.push({"id":"62","name":"Consultation Request","parent_id":"6","red_link":"../view_consultation","description":"","display_option":"menu"});
  
      listRoles.push({"id":"4","name":"Reports","parent_id":"0","red_link":"../compliance_list","description":"","display_option":"menu"});
      listRoles.push({"id":"42","name":"Order Wise","parent_id":"4","red_link":"../online_orders","description":"","display_option":"menu"});
      //listRoles.push({"id":"42","name":"Purchase Product Wise","parent_id":"4","red_link":"../online_orders","description":"","display_option":"menu"});
      listRoles.push({"id":"42","name":"Purchase Product Analytics","parent_id":"4","red_link":"../product_analytics","description":"","display_option":"menu"});
    }
    
    if(_initObjectLib.app_settings.settings.menu_category["menu_type"]==="all" || _initObjectLib.app_settings.settings.menu_category["menu_type"]==="cms")
    {
      listRoles.push({"id":"7","name":"CMS Mgmt","parent_id":"0","red_link":"../user_profile","description":"","display_option":"menu"});
      listRoles.push({"id":"71","name":"CMS View","parent_id":"7","red_link":"../cms_view","description":"","display_option":"menu"});
      listRoles.push({"id":"71","name":"CMS Data","parent_id":"7","red_link":"../cms_data","description":"","display_option":"menu"});
    }
    if(_initObjectLib.app_settings.settings.menu_category["contact_option"]==="cms_contact"){
      listRoles.push({"id":"8","name":"View Message","parent_id":"0","red_link":"../view_messages","description":"","display_option":"menu"});
    }
    if(_initObjectLib.app_settings.settings.menu_category["menu_type"]==="astrosaxena"){
      listRoles.push({"id":"1","name":"View Comment","parent_id":"0","red_link":"../astro_messages","description":"","display_option":"menu"});
      listRoles.push({"id":"2","name":"View Subscribers","parent_id":"0","red_link":"../astro_subscriber","description":"","display_option":"menu"});
      listRoles.push({"id":"2","name":"View Contacts","parent_id":"0","red_link":"../astro_contacts","description":"","display_option":"menu"});
      listRoles.push({"id":"2","name":"List Articles","parent_id":"0","red_link":"../astro_articles","description":"","display_option":"menu"});

    }
    if(_initObjectLib.app_settings.settings.menu_category.default_list.indexOf("nomination_form")!==-1){
      listRoles.push({"id":"8","name":"Nomination Requests","parent_id":"0","red_link":"../list_nomination_req","description":"","display_option":"menu"});
    }
    
   
    //listRoles.push({"id":"41","name":"Wapp Reports","parent_id":"4","red_link":"../wapp_reports","description":"","display_option":"menu"});
    //listRoles.push({"id":"42","name":"Wapp Button Reports","parent_id":"4","red_link":"../wapp_button_reports","description":"","display_option":"menu"});
    

    
    //listRoles.push({"id":"7","name":"Manage APIs","parent_id":"0","red_link":"../abstract_noticesssss","description":"","display_option":"menu"});
  }
  
  
   
    if(localStorage.getItem("userDS")!=null){
      userObject= JSON.parse(localStorage.getItem("userDS"));
      //alert(JSON.stringify(userObject));
      loginUser=userObject[0].first_name;
      if(typeof userObject[0].company_name!=="undefined"){
        companyName=userObject[0].company_name;
      }
  }
  }
  callBackNg(data,msg){
   var check=JSON.parse(data);
   if(check.length==0){
    // alert("Invalid User !Kindly contact to Admin")
    localStorage.clear();
    window.location.href="../";
   }
  }
  
  componentDidMount(){

    
    if(listRoles.length!=0){
      //alert("i am in ");
      var listHtm=getAccessRolesNew(listRoles);
     
     $("#menu_opt").append(listHtm);
    }
    
  }
 
    render(){
        return(//  <!-- Navbar -->
          <div>
          <nav className="main-header navbar navbar-expand-md  navbar-light navbar-white my-shadow">
          <div className="container-fluid "> <a href="/dashboard" className="navbar-brand"> <img style={{/*"background-color":"#000"*/}} src={_initObjectLib["logoPath"]} alt="HrTech" className="brand-image elevation-3 img-thumbnail" /> <span className="brand-text " ></span> </a>
            <button className="navbar-toggler order-1 me-hide" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span> </button>
            <div className="collapse navbar-collapse order-3" id="navbarCollapse"> 
           
              {/* <!-- Left navbar links -->  */}
              
              {/* <!-- SEARCH FORM -->  */}
              
            </div>
          
            
            {/* <!-- Right navbar links --> */}
            <ul className="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto">
            {/* <select className="form-control">
                 <option>Year</option>
                 <option>2021</option>
            </select> */}
              {/* <!-- Messages Dropdown Menu --> */}
              <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i style={{fontSize:"2em"}} class="fa fa-bell"></i>
          <span class="badge badge-warning navbar-badge" id="count_notification"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="../recent_notification" class="dropdown-item">
            <i class="fa fa-envelope mr-2"></i>Recent Compliance
            <span class="badge badge-warning float-right text-muted text-sm" id="compliance_count"></span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fa fa-users mr-2"></i>Recent Notices
            <span class="float-right text-muted text-sm" id="notices_count"></span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fa fa-file mr-2"></i>ACTA Updates
            <span class="float-right text-muted text-sm" id="acta_count"></span>
          </a>
          <div class="dropdown-divider"></div>
          {/* <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a> */}
        </div>
      </li>
        
            
              <li className="nav-item dropdown12"> <a className="nav-link" data-toggle="dropdown" href="#"> <i style={{fontSize:"2em"}} className="fa fa-user fa-2x"></i> </a>
                <div id="dropdown12" className="dropdown-menu dropdown-menu-lg dropdown-menu-right"> 
                  <div className="dropdown-divider"></div>
                  <a href="#" className="dropdown-item"> <i className="fa fa-book mr-2"></i> <b>Entity:</b> {companyName}</a>
                  <a href="#" className="dropdown-item"> <i className="fa fa-user mr-2"></i> Welcome {loginUser}</a>
                  <div className="dropdown-divider"></div>
                  
                  <a href="javascript:void(0)" onClick={()=>this.logout()} className="dropdown-item"> <i className="fa fa-sign-out mr-2"></i> Logout </a>
                  <div className="dropdown-divider"></div>
                  </div>
              </li>
            </ul>
          </div>
        </nav>
          <nav class="navbar navbar-expand-lg my-bg-color-1 my-shadow">
          <a class="navbar-brand text-white ml-3" href="#"><i class="fa fa-user-circle"></i> {loginUser}  </a>
          <ul class="navbar-nav">
              
          </ul>
        
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#nav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"><i class="fa ffg fa-bars "></i></span>
          </button>
        
          <div class="collapse navbar-collapse" id="nav">
        
        
              <ul id="menu_opt" class="navbar-nav bg-light-my m-0 ml-lg-auto mr-lg-auto p-3 p-lg-0 m-auto1">
              <li class="d-inline d-lg-none">
                <button data-toggle="collapse" data-target="#nav" class="close float-right">&times;</button>
            </li>
            <li class="nav-item d-lg-none d-md-none d-sm-none  "><img src={UserDefault} width="80" class="img-circle img-thumbnail img-fluid m-auto text-cente" />
				<h6 class="mt-4">Good-Morning {loginUser} </h6>
				<div class="border-bottom w-100 mt-1 mb-1"></div>
			
			</li>
              </ul>
          </div>
      </nav>


      </div>
          )
    }
}
export default Header